export default {
    // BASE_URL: 'http://127.0.0.1:8000',
    BASE_URL: 'https://apiroot.enginehire.io',
    // BASE_WS_URL: "ws://127.0.0.1:5000"
}


// WEBPACK FOOTER //
// ./src/environments/development.js